/**
 * Enum for describing styles of a link to indicate its visual importance or role.
 */
export enum VisualStyle {
  Default = 'default',     // Standard styling, no emphasis.
  Highlighted = 'highlighted', // Styling that draws attention or importance to the link.
  Underlined = 'underlined'   // Always underlined, regardless of state or interaction.
}
